// extracted by mini-css-extract-plugin
export default {"fluid":"FieldBinaryToggle_fluid__XpjyI","buttonFluid":"FieldBinaryToggle_buttonFluid__jrdPh"};